<template>
    <div class="container">
        <h2>New Role</h2>
		<div>
			<router-link to="/roles" class="btn btn-link">
				<i class="fas fa-arrow-left"></i> Back to Roles List
			</router-link>
		</div>
		<form @submit.prevent="submitForm" class="form-horizontal col-sm-6">
			<div class="form-group row">
				<label for="code" class="col-sm-4 col-form-label text-right">Code *</label>
				<div class="col-sm-8">
					<input type="text" class="form-control" id="code" required>
				</div>
			</div>
			<div class="form-group row">
				<label for="description" class="col-sm-4 col-form-label text-right">Description *</label>
				<div class="col-sm-8">
					<input type="text" class="form-control" id="description" required>
				</div>
			</div>
			<div class="form-group row">
				<label for="permissions" class="col-sm-4 col-form-label text-right">Permissions</label>
				<div class="col-sm-8">
					<div v-for="permission in allPermissions" :key="permission" class="form-check">
						<input
							type="checkbox"
							class="form-check-input"
							:id="permission"
							:value="permission">
						<label class="form-check-label" :for="permission">{{ permission }}</label>
					</div>
				</div>
			</div>
			<div class="form-group row">
				<div class="col-sm-8 offset-sm-4">
					<button type="submit" class="btn btn-primary">
                        <output v-if="loading" class="spinner-border spinner-border-sm" aria-hidden="true"></output>
                        Save
                    </button>
				</div>
			</div>
		</form>
    </div>
</template>

<script>
import api from '@/api';
import eventBus from '@/utils/eventBus';
import { checkAuth } from '@/utils/auth';

export default {
    data() {
		return {
			allPermissions: [],
            loading: false
		};
	},
	async mounted() {
		if (!(await checkAuth())) {
			eventBus.emit('show-alert', { message: 'You need to log in to access this page.', type: 'danger' });
			this.$router.push('/');
		} else {
			await this.fetchPermissions();
		}
	},
	methods: {
		async fetchPermissions() {
			try {
				const response = await api.get('/v1/permissions', {
					headers: {
						Authorization: `Bearer ${localStorage.getItem('accessToken')}`
					}
				});

				if (response.status === 200) {
					this.allPermissions = response.data.data.permissions;
				} else {
					eventBus.emit('show-alert', { message: response.data.message, type: 'danger' });
				}
			} catch (err) {
				console.error(err);
				if (err.response) {
					console.error(err.response.data);
				}
			}
		},
		async submitForm() {
            this.loading = true;
			if (!(await checkAuth())) {
                eventBus.emit('show-alert', { message: 'You need to log in to access this page.', type: 'danger' });
                this.$router.push('/');
            } else {
                try {
                    const response = await api.post('/v1/roles', {
                        code: document.getElementById('code').value,
                        description: document.getElementById('description').value,
                        permissions: this.allPermissions.filter(permission => document.getElementById(permission).checked).join(','),
                        active: 'true'
                    }, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                        }
                    });

                    if (response.status === 201) {
                        eventBus.emit('show-alert', { message: response.data.message, type: 'success' });
                        this.$router.push('/roles');
                    } else {
                        eventBus.emit('show-alert', { message: response.data.message, type: 'danger' });
                    }
                } catch (err) {
                    console.error(err);
                    if (err.response) {
                        console.error(err.response.data);
                        eventBus.emit('show-alert', { message: err.response.data.message, type: 'danger' });
                    }
                }
            }
            this.loading = false;
		}
	}
};
</script>

<style>
.form-horizontal .form-group {
    margin-top: 1rem;
	margin-bottom: 1rem;
}
</style>
